export default "__VITE_ASSET__Dp$TjNtv__";